import axios from 'axios';
import config from './config';

const API_BASE_URL = config.API_BASE_URL;

export const addFavorite = async (userId, productId, branchId) => {
  let url = `${API_BASE_URL}/Favorites/Add?userId=${userId}&productId=${productId}`;
  if (branchId) url += `&branchId=${branchId}`;
  const response = await axios.post(url);
  return response.data;
};

export const removeFavorite = async (userId, productId, branchId) => {
  let url = `${API_BASE_URL}/Favorites/Remove?userId=${userId}&productId=${productId}`;
  if (branchId) url += `&branchId=${branchId}`;
  const response = await axios.delete(url);
  return response.data;
};

// ✅ UPDATED: Add currency parameter
export const getFavorites = async (userId, branchId, currency = 'YER') => {
  let url = `${API_BASE_URL}/Favorites/Get?userId=${userId}`;
  if (branchId) url += `&branchId=${branchId}`;
  if (currency) url += `&currency=${currency}`; // ✅ NEW
  
  const response = await axios.get(url);
  return response.data;
};

export const getFavoriteIds = async (userId, branchId) => {
  let url = `${API_BASE_URL}/Favorites/GetIds?userId=${userId}`;
  if (branchId) url += `&branchId=${branchId}`;
  const response = await axios.get(url);
  return response.data;
};
